export default __webpack_public_path__ + "static/media/WebinarTeachers.e443286f.jpg";